import React from 'react';
import Chatbox from './components/chatbox';
import './App.css';

function App() {
  return (
    <div className="App chatbox-embed-root">
      <Chatbox />
    </div>
  );
}

export default App;
